import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CollectionStore from '../store/collection';
import '@fiverr/globals';
import translations from '../translations.en.json';
import GigCard from './GigCard';
import GigCardsRepeater from '../shared/gig_cards_repeater';
import './style.scss';

class GigCards extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            unmounting: false,
            collections: false
        };

        i18n.add(translations);

        this.getCollections = this.getCollections.bind(this);
        this.updateCollections = this.updateCollections.bind(this);
    }

    componentDidMount() {
        if (this.props.user) {
            this.getCollections().then((json) => { this.setState({collections: json}); });
        }
    }

    updateCollections(collections) {
        this.setState({ collections });
    }

    getCollections() {
        const {gigs, user} = this.props,
            hearts = gigs.map((gig) => gig.gig_id);

        if (!user) {
            return;
        }

        return CollectionStore.getCollections(hearts).then((json) => { this.setState({collections: json}); return json; });
    }

    render() {
        const {gigs, user, cardSize, responsiveGrid, context = {}} = this.props,
            {collections} = this.state;

        return (
            <GigCardsRepeater context={{ cardType: 'card', cardSize, collections, user, ...context }} responsiveGrid={responsiveGrid}>
                {gigs.map((gig) => 
                    <GigCard key={gig.gig_id} gig={gig} updateCollections={this.updateCollections} user={user} context={context}/>
                )}
            </GigCardsRepeater>
        );
    }
}

GigCards.propTypes = {
    responsiveGrid: PropTypes.bool,
    user: PropTypes.object,
    gigs: PropTypes.array,
    cardSize: PropTypes.string,
    context: PropTypes.shape({
        pageCtxId: PropTypes.string,
        refCtxId: PropTypes.string
    })
};

GigCards.defaultProps = {
    cardSize: 'medium',
    responsiveGrid: false
};

export default GigCards;



// WEBPACK FOOTER //
// ./src/mp_gig_card/index.js